import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { DirectivesModule } from '@commons/directives/directives.module';
import { IDropdownMenuOptions } from '@src/app/interfaces/dropdown-menu.interface';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, DirectivesModule]
})
export class DropdownMenuComponent implements OnInit {

  @Input('options') public set setOptions(data: IDropdownMenuOptions[]) {
    this.options = [
      ...data.map(item => ({
        ...item,
        img: item.img && this.sanitizer.bypassSecurityTrustHtml(item.img as string) }
      ))
    ];
  }

  public options: IDropdownMenuOptions[] = [];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

}
